var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-filtered-multiselect',{attrs:{"value":_vm.storedCustomers,"options":_vm.customerOptions,"placeholder":_vm.placeholder,"limit-height":_vm.limitHeight,"hide-selected":_vm.hideSelected,"disabled":_vm.disabled,"track-by":"value","label":"label"},on:{"input":_vm.onCustomersSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }